import { EventInput } from '@fullcalendar/core';
import { Goal, WeekDays } from '@griply/types';
import { getGoalsCalendarEvents } from '@griply/utils';

import { mapCalendarEventToEventInput } from './map-calendar-event-to-event-input';

export const getGoalsDeadlineEvents = (
  goals: Goal[],
  weekStartsOn: WeekDays,
): EventInput[] =>
  getGoalsCalendarEvents(goals).map((event) =>
    mapCalendarEventToEventInput(event, undefined, weekStartsOn),
  );
